import { BybButtonVR } from "@Components/game/common";
import { styled } from "@mui/material";

export const StyledVRWhatsNewButton = styled(BybButtonVR)(({ theme }) => ({
  background: theme.palette.dsPrimaryGradient.orange,
  transition: "opacity 0.25s ease",
  color: theme.palette.common.black,
  "&:hover": {
    background: theme.palette.dsPrimaryGradient.orange,
    opacity: 0.8,
    "* > span, div": {
      color: theme.palette.common.black,
      opacity: 1,
      transitionDuration: "0.25s",
    },
  },
}));
